import React from 'react';
import './AppLoading.css';

/* THE ONE LOADING SURFACE for the sign-up → paywall → app path. There used to
   be three: the AuthProvider rendered nothing (so the light --brand-bg showed),
   and the subscription gate and the paywall each drew their own black screen
   with grey "Loading…". Between a blue login form and a dark paywall that was
   light-dark-black in a second. This is the splash's navy with the mark on it,
   so a wait reads as the app opening rather than as a gap between screens. */
export default function AppLoading() {
  return (
    <div className="app-loading" role="status" aria-label="Loading">
      <img
        src={`${process.env.PUBLIC_URL}/1_19_logo.png`}
        alt=""
        className="app-loading-mark"
      />
      <span className="app-loading-dots" aria-hidden="true">
        <span /><span /><span />
      </span>
    </div>
  );
}
